import React, { useEffect, useState } from 'react';
import { formatCurrency } from '../../components/formatters';
import { isObjectModified } from '../../components/property-mapper';
import CompareField from './compare-field';
import { EnrollmentType } from '../../components/enums/enrollment-type';
import { PlanType } from '../../components/enums/plan-type';

const HealthReview = ({title, planType, modifiedSelections, unmodifiedSelections, addDeduction, enrollments}) => {
    const [isModified, setIsModified] = useState();
    const [modified, setModified] = useState();
    const [unmodified, setUnmodified] = useState();
    const [allDependents, setAllDependents] = useState();
    const [deduction, setDeduction] = useState();

    useEffect(() => {
        const m =modifiedSelections?.find(s => s.planType === planType);
        const u = unmodifiedSelections?.find(s => s.planType === planType);
        console.log(planType, "modified", m, "UNMOD", u);
        setModified(m);
        setUnmodified(u);
        if(enrollments.enrollmentTypeId !== EnrollmentType.NewHire && !u && (!m || m?.planId === "WAIVED")) {
            setIsModified(false);
        }else {
            setIsModified(isObjectModified(m?.dependents, u?.dependents));
        }
        const plan = enrollments.plans.find(s => s.id === m?.planId);
        const ded = plan?.options?.find(s => s.id === m?.planOption)?.cost;
        if(ded){
            setDeduction(ded);
            addDeduction(ded);
            }
        let dependents
        if(!m && !u)
            dependents = [];
        else if(!m)
            dependents = u?.dependents;
        else if (!u)
            dependents = m?.dependents;
        else{
            dependents = m?.dependents?.concat(u.dependents);
            let set = new Set(dependents);
            dependents   = Array.from(set);
        }

        setAllDependents(dependents);

    }, []);

    const getPlanOptionName = (planId, planOption) => {
        var plan = enrollments?.plans?.find(s => s.id === planId);
        if(!plan)
            return null;
        
        const optionName = plan.options.find(s => s.id === planOption)?.name;
        console.log("OPTION NAME", optionName);
        return optionName;
        
    }

    const getPlanName = (planId, planType) => {
        if(planId === "WAIVED" && planType && planType === PlanType.Medical){
            planId = "MED";
        }
        const planName = enrollments?.plans?.find(s => s.id === planId)?.providerName;
        console.log("planName", planName, "PlanId", planId);
        return planName;
    }

    const getDependentName = (dependentId) => {
        const dependent = enrollments?.contacts?.find(s => s.id === dependentId);
        if(!dependent)
            return dependentId;

        return `${dependent.firstName} ${dependent.lastName}`;
    }



    return ( 
        <div className="mb-4">
            <div className='grid grid-cols-2 items-center mb-2 w-96'>
                <div className='text-xl'><span className={isModified ? 'text-purple' : 'text-danger'}>{title} </span></div>
                
                <div className="text-xs border-l border-solid border-slate-600 pl-8">Paycheck Deduction: {formatCurrency(deduction, 2)}</div>
            </div>
            <CompareField title="Plan" modifiedValue={getPlanName(modified?.planId, modified?.planType)} unmodifiedValue={getPlanName(unmodified?.planId)} />
            <CompareField title="Tier" modifiedValue={getPlanOptionName(modified?.planId, modified?.planOption) ?? "Waived Coverage"} unmodifiedValue={getPlanOptionName(unmodified?.planId, unmodified?.planOption) ?? "Waived Coverage"} />
            {allDependents ?
            <>
                <div className='text-xs'>Dependents</div>
                <ol className="list-decimal ml-8">
                {allDependents.map((d, idx) => {
                    return(
                        <li key={idx}>
                            <p>
                            <CompareField modifiedValue={getDependentName(modified?.dependents?.find(s => s === d))}  unmodifiedValue={getDependentName(unmodified?.dependents?.find(s => s === d))}   />
                            </p>
                        </li>
                    );
                }
                )}
                </ol>
            </>
            :
            <></>
            }

           <hr />
        </div>
     );
}
 
export default HealthReview;